'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../../../../styleInject.js');

var css_248z = ".EmptyResults-module_emptyResults__QjcFY{border:1px dashed #dddbda;justify-items:center;padding:1rem 4rem;text-align:center}";
var styles = {"emptyResults":"EmptyResults-module_emptyResults__QjcFY"};
styleInject["default"](css_248z, '33413749-5bcb-489b-946b-703b33740d37');

exports["default"] = styles;
